import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { MasterActions } from "@MasterBluePrint/Store/MasterState";
import { DispatchProp } from "react-redux";

interface Parameter {
    modalIsOpen: boolean;
    productNumber?: string;
}

type HandlerType = Handler<Parameter, DispatchProp<MasterActions>>;

export const DispatchSetRequestQuoteModalIsOpen: HandlerType = props => {
    props.dispatch({
        type: "Components/RequestQuoteModal/CompleteSetIsOpen",
        modalIsOpen: props.parameter.modalIsOpen,
        productNumber: props.parameter.productNumber,
    });
};

export const chain = [DispatchSetRequestQuoteModalIsOpen];

const setRequestQuoteModalIsOpen = createHandlerChainRunner(chain, "SetRequestQuoteModalIsOpen");
export default setRequestQuoteModalIsOpen;
